<template>
    <div>
        <header class="header margin-b-25">
            <h1>Rabatkode</h1>
        </header>

        <transition name="fade" mode="out-in">

            <div v-if="!order.coupon" key="form">
                <div class="input-group col-12 margin-b-25">
                    <form @submit.prevent="checkCoupon">
                        <input class="col-6" type="text" placeholder="Rabatkode" id="coupon" name="coupon" v-model="code" :disabled="isCheckingCoupon">
                        <button type="submit" class="btn--primary btn--sm primary--copper" id="submitCoupon" :disabled="!validateCode || isCheckingCoupon" @click="checkCoupon">
                            <span v-if="!isCheckingCoupon">Indløs</span>
                            <span v-else>
                            <i class="spinner--light"></i>
                            Indløser
                        </span>
                        </button>
                    </form>
                </div>

                <div class="col-12 error" v-if="responseMessage">
                    <p>{{responseMessage}}</p>
                </div>
            </div>

            <div v-else key="coupon">
                <div class="col-12 margin-b-25 " v-if="couponData">

                     <a href="#" class="btn--secondary" id="removeCoupon" @click.prevent="removeCoupon">{{couponData.title}} <i class="icon--lg fas fa-times"></i></a>
                </div>
            </div>
        </transition>

    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "couponField",
        data(){
            return {
                code:'',
                responseMessage:'',
                isCheckingCoupon:false,
            }
        },
        computed:{
            ...mapGetters(['order', 'product', 'couponData']),
            email(){
                return this.order.information.email;
            },
            slug(){
                return this.product.slug;
            },
            validateCode(){
                return String(this.code).length > 0;
            }
        },
        methods:{
            checkCoupon(){
                if(!this.validateCode){
                    return;
                }

                this.responseMessage = '';

                this.isCheckingCoupon = true;

                axios.post('/api/public/coupon', {
                    code:this.code,
                    email:this.email,
                    slug:this.slug,
                }).then(response => {
                    setTimeout(()=>{
                        this.isCheckingCoupon = false;
                        this.$store.dispatch('setCoupon', response.data.data);
                        this.code = '';
                    }, 1500);

                }).catch(error => {
                    setTimeout(()=>{
                        this.isCheckingCoupon = false;
                        this.code = '';

                        if(error.response.data.status === 'invalid'){
                            return this.responseMessage = 'Rabatkoden er ugyldig';
                        }

                        if(error.response.data.status === 'used'){
                            return this.responseMessage = 'Du har allerede benyttet denne rabatkode';
                        }

                    }, 1500);



                })
            },
            removeCoupon(){
                this.$store.dispatch('clearCoupon');
            }
        }
    }
</script>

<style scoped>

</style>
